import React from 'react';

interface NumericalCellProps {
  row: any;
  field: string;
  isCurrency?: boolean;
}

const NumericalCell: React.FC<NumericalCellProps> = ({
  row,
  field,
  isCurrency = false,
}) => {
  const value = row?.[field] || 0;

  let formattedValue: string;
  if (isCurrency) {
    formattedValue = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Number(value));
  } else {
    formattedValue = Number(value).toLocaleString();
  }

  return <div className="w-full text-right">{formattedValue}</div>;
};

export default NumericalCell;
